export default "__VITE_ASSET__VdvrV9kB__"